module.exports = __webpack_public_path__ + "static/overlay_logo-3751445d124eacf22a460cb1e4ee6a64.png";